import './App.css';
import theme from "./Components/theme";
import Footer from "./Components/footer";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, ThemeProvider, CssBaseline, Button } from '@mui/material';
import { Link } from "react-router-dom";

export default function App() {
  const [pageBackgroundPicture, setPageBackgroundPicture] = useState();

  useEffect( () => {
    makeRequest();
  },[]);

  const useStyles ={
    landingPage:{
      background: (pageBackgroundPicture !== undefined)? `/* top, transparent black, faked with gradient */ 
      linear-gradient(
        rgba(0, 0, 0, 0.2), 
        rgba(0, 0, 0, 0.2)
      ),
      /* bottom, image */ url(${pageBackgroundPicture.urls.regular}) no-repeat` : "black",
      minHeight: "125vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "5vh",
      padding: "0em"
    },

    text:{
      marginTop: "6vh"
    },

    button:{
      fontSize: '1.4em',
      marginTop:"9vh",
      borderRadius: ".4em",
      padding: ".2em",
      fontWeight: "300"
    }
  }

  async function makeRequest () {
    axios.request("https://fathomless-wave-33104.herokuapp.com/Images/", {params : {"pictureID" : "CpHNKNRwXps"}})
    .then((response) => {setPageBackgroundPicture(response.data)})
    .catch((error) => console.log("Error: ", error));
  }
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Box style={useStyles.landingPage} className={"landingPage"}>
          <Typography variant="h4" style={useStyles.text} fontSize={{xl: 130, lg: 70, md: 70, sm: 70, xs: 40}}>ISS Daily Reports</Typography>
          <Typography variant="h6" color={"primary"} fontSize={{xl: 55, lg: 30, md: 32, sm: 30, xs: 18}} m={1} fontWeight={800} >Powered by <a className="Link" href="https://thespacedevs.com/">TheSpaceDevs</a></Typography>
          <Button variant="outlined" color={"primary"} style={useStyles.button} mt={2} ><Link className="Link" to={"/Space_Reports"}>Explore</Link></Button>
        </Box>
        <Footer/>
      </div>
    </ThemeProvider>
  );
}